Arrows = {
	el:{},
	prev:{},
	next:{},
	isActive:false,

	init:function(PAGE) {

		PAGE = PAGE ? PAGE : $('body');
		this.remote = PAGE.find('[data-method="getSliderRemote"]');
		if(!this.remote.length) return;

		this.bind();

	},

	bind: function(){

		this.remote.unbind("mousedown");
		this.remote.on("mousedown", ".next", function() {
			$(this).closest('section').attr('direction', 'next');
		});

		this.remote.on("mousedown", ".prev", function() {
			$(this).closest('section').attr('direction', 'prev');
		});

		this.remote.on("mousedown", ".close", function() {
			$(this).closest('section').attr('direction', 'close');
		});

	},

	remove: function(){
		if (!this.isActive) return;
		this.isActive = false;

		// this.page.removeAttr('direction');
	},

}